<template>
<div class="ptb-20 border-t-b">
  <div class="container">
    <div class="slider-content">
      <h2 class="cd-headline clip is-full-width">Hello, I am Fredericka & 
        <vue-typed-js 
        :strings="['Design thinker', 'problem solver','empath']"
        :typeSpeed="100"
        :backSpeed="30"
        :loop="true"
        :loopCount="10"
        :showCursor="false">
          <span class="cd-words-wrapper">
            <b class="is-visible typing"></b>
          </span>
        </vue-typed-js>
      </h2>
      <p>User Experience Designer</p>
      <router-link class="btn" to="/about">About Me</router-link>
    </div>
  </div>
  <div class="basic-portfolio-area ptb-90">
    <div class="container">
      <div class="filter-menu text-center mb-40">
        <button 
          v-for="(filter,index) in categories"
          v-bind:key="index"
          @click="filterIsotope(filter)"

          :class="{ active : activeFilter == filter }">{{filter}}</button>
      </div>
      <div id="portfolio-grid" class="row-portfolio">
        <isotope
          v-images-loaded:on.progress="updateIsotopeLayout"
          ref="portfolioIsotope"
          :options='getOptions()'
          :list="projectList"
          itemSelector="portfolio-item">
          <div v-for="project in projectList" :key="project.code">
              <div class="portfolio-wrapper">
                <div class="portfolio-thumb">
                  <img :src="project.thumbnail.image" :alt="project.thumbnail.alt" />
                  <div class="view-icon">
                    <router-link class="popup-link" :to="`/portfolio/${project.code}`"><span class="fa-fix fa fa-search"></span></router-link>
                  </div>
                </div>
                <div class="portfolio-caption caption-border text-center">
                  <h4><router-link :to="`/portfolio/${project.code}`">{{project.title}}</router-link></h4>
                  <div class="work-tag">
                    <span>{{project.summary}}</span>
                  </div>
                </div>
              </div>
          </div>              
        </isotope>
      </div>		
      <div class="view-more mt-20 text-center">
        <a class="btn btn-large" href="http://www.fredericka.me/2018/#portfolio"><i class="fa fa-external-link"></i> Website 2018</a>
			</div>
    </div>
  </div>
</div>
</template>

<script>
import isotope from 'vueisotope';
import axios from 'axios';
import imagesLoaded from 'vue-images-loaded';

export default {
  name: "Home",
  components: {
    isotope
  },
  data() {
    return {
      projectList: [],
      categories: ["all","ux","design system","visual"],
      activeFilter: "all"
    }
  },
  directives: {
    imagesLoaded,
  },
  methods: {
    getOptions() {
      const component = this;
      return {
        percentPosition: true,
        getFilterData:{
          category: function(item){
            if(component.activeFilter == component.categories[0])
              return true;
            return item.categories.includes(component.activeFilter);
          }
        }
      }
    },
    filterIsotope(filter) {
      this.activeFilter = filter;
      this.$refs.portfolioIsotope.filter("category");
    },
    updateIsotopeLayout() {
      this.$refs.portfolioIsotope.layout("masonry");
    }
  },
  created() {
    axios.get(`/static-api/projects.json`).then(response => {
      this.projectList = response.data;
    }).catch(e => {
      // eslint-disable-next-line
      console.error(e);
    });
  }
}
</script>
<style scoped>
.fa-fix {
  font-size: 15px;;
}
</style>